export default {
  "unableToLoadStations": "Désactiver les stations de chargement",
  "unableToLoadOutlets": "Incapables aux prises de charge",
  "unableToFetchLaunchLink": "Impossible de chercher le lien de lancement",
  "stationUpdated": "Station mise à jour",
  "stationCreated": "Station créée",
  "unableToSaveStation": "Incapable d'enregistrer une station",
  "createStation": "Créer une station",
  "createRoute": "Créer un itinéraire",
  "activeStations": "Stations actives",
  "stationsReadyToAcceptNewTickets": "Stations prêtes à accepter de nouveaux billets.",
  "activeRoutes": "Routes actives",
  "liveRoutingRulesForAllStations": "Règles de routage en direct pour toutes les stations.",
  "ticketsInQueue": "Billets dans la file",
  "comingFromLiveKDSOrders": "Venant des ordres de KDS en direct.",
  "stationsAtAGlance": "Stations en un coup d'oeil",
  "quickOverviewOfYourKitchenStationFleet": "Aperçu rapide de la flotte de votre station de cuisine.",
  "launchLinks": "Liens de lancement",
  "noStationsConfigured": "Pas de stations configurées",
  "createYourFirstKDSStationToBeginRoutingTickets": "Créez votre première station KDS pour commencer les billets de routage.",
  "noOutletLinked": "Pas de sortie liée",
  "active": "Actif",
  "inactive": "Inactif",
  "launchLink": "Lien de lancement",
  "launchLinkCopied": "Lien de lancement copié",
  "selectAStationToGenerateALaunchLink": "Sélectionnez une station pour générer un lien de lancement.",
  "secureStationURLRotatingOTP": "Station sécurisée URL + rotation OTP .",
  "stationURL": "URL de station",
  "launchLinkNotReady": "Lien de lancement non prêt",
  "copyStationURL": "Copier l'URL de station",
  "onetimePasscode": "Code de passe unique",
  "expiresIn": "Expirant",
  "qRPending": "Code QR en attente",
  "scanToOpenKDSStation": "Scanner pour ouvrir la station KDS",
  "thisStationIsCurrentlyDisabledLaunchLinksWillStillWorkButServiceWillBeLimited": "Cette station est actuellement désactivée. Les liens de lancement fonctionnent encore, mais le service sera limité.",
  "product": "Produit",
  "prepCategory": "Catégorie prép",
  "productCategory": "Catégorie de produit",
  "outlet": "Sortie",
  "outletType": "Type de sortie",
  "defaultCatchall": "Capture par défaut",
  "bar": "Bar",
  "dining": "Salle à manger",
  "proShop": "Pro Shop",
  "halfwayHouse": "Maison à mi-chemin",
  "chooseWhatTriggersThisRoute": "Choisissez ce qui déclenche cette route",
  "chooseAMatchingValue": "Choisissez une valeur correspondante",
  "chooseAKDSStation": "Choisissez une station KDS",
  "editRoute": "Modifier la route",
  "productsMarkedAsRequiringKDSAreSentToTheFirstMatchingActiveRoute": "Les produits marqués comme nécessitant la KDS sont envoyés à la première route active correspondante.",
  "moreSpecificRoutesWinAutomaticallyForExampleProductBeatsPrepCategoryAndPrepCategoryBeatsDefault": "Des itinéraires plus spécifiques gagnent automatiquement. Par exemple, Product beats Prep category, et Prep category beats Default.",
  "whatShouldTriggerThisRoute": "Qu'est-ce qui devrait déclencher cette route ?",
  "chooseTrigger": "Choisissez le déclencheur",
  "ePOSProduct": "produit ePOS",
  "searchForAnEPOSProduct": "Recherche d'un produit ePOS",
  "searching": "Recherche…",
  "searchAndSelectAProduct": "Recherchez et sélectionnez un produit.",
  "choosePrepCategory": "Choisissez la catégorie prép",
  "chooseProductCategory": "Choisir catégorie de produits",
  "chooseOutlet": "Choisissez un point de vente",
  "unnamedOutlet": "Sortie sans nom",
  "chooseOutletType": "Choisissez le type de sortie",
  "defaultCatchesKDSrequiredItemsThatDoNotMatchAnotherRoute": "Défaut attrape des articles KDS-requis qui ne correspondent pas à une autre route.",
  "sendTicketsTo": "Envoyez des billets",
  "chooseKDSStation": "Choisissez la station KDS",
  "routeActive": "Route active",
  "useThisRouteWhenItMatches": "Utilisez cette route quand elle correspond.",
  "cancel": "Annuler",
  "saveRoute": "Sauvegardez la route",
  "unableToLoadRoutes": "Impossible de charger les itinéraires",
  "routeUpdated": "Route mise à jour",
  "routeCreated": "Route créée",
  "unableToSaveRoute": "Incapable de Enregistrer la route",
  "routeDeleted": "Route supprimée",
  "unableToDeleteRoute": "Impossible de supprimer la route",
  "default": "Par défaut",
  "routingRules": "Règles de routage",
  "whenThisMatchesSendTicketsThereProductsMarkedAsRequiringKDSAreSentToTheFirstMatchingActiveRoute": "Lorsque cela correspond, envoyez des billets là-bas. Les produits marqués comme nécessitant KDS sont envoyés à la première route active correspondante.",
  "noRoutingRulesYet": "Pas encore de règles de routage",
  "createADefaultRouteToCatchUnmatchedKDSItems": "Créer un itinéraire par défaut pour capturer des éléments KDS sans égal.",
  "createPrepCategoryRoutesSuchAsDrinksBarAndFoodKitchen": "Créer des itinéraires de catégorie prép tels que les boissons → Bar et Alimentation → Cuisine.",
  "edit": "Modifier",
  "deleteRoute": "Supprimer la route",
  "thisRoutingRuleWillBeRemovedImmediately": "Cette règle de routage sera supprimée immédiatement.",
  "stationNameIsRequired": "Le nom de la station est requis",
  "editKDSStation": "Modifier la station KDS",
  "createKDSStation": "Créer une station KDS",
  "stationName": "Nom de la station",
  "mainKitchen": "Cuisine principale",
  "stationActive": "Station active",
  "allowThisStationToReceiveRoutedKDSTickets": "Permettre à cette station de recevoir des billets KDS.",
  "soundEnabled": "Son activé",
  "playAToneWhenNewTicketsArrive": "Jouez un ton quand de nouveaux billets arrivent.",
  "autobumpMinutes": "Minutes auto-bump",
  "automaticallyCompleteItemsAfterThisManyMinutesUse0ToKeepOff": "Effectuez automatiquement les articles après ces nombreuses minutes. Utilisez 0 pour garder le feu.",
  "saveStation": "Station d'enregistrement",
  "stations": "Stations",
  "selectAStationToManageLaunchLinks": "Sélectionnez une station pour gérer les liens de lancement.",
  "createYourFirstStation": "Créez votre première station",
  "stationsPowerTheKDSLayoutAndLaunchLinks": "Les stations alimentent la mise en page KDS et les liens de lancement.",
  "routesDecideWhereKDSrequiredItemsGo": "Les itinéraires décident où les articles KDS-requis vont.",
  "disabled": "Désactivé",
  "editStation": "Modifier la station",
  "stationDetails": "Détails de la station",
  "configurationSummaryForThisStation": "Résumé de la configuration pour cette station.",
  "on": "On y va.",
  "off": "Officier",
  "autobump": "Avancement automatique",
  "technicalKeyKey": "Clé technique: {key}",
  "selectAStationToViewDetails": "Sélectionnez une station pour voir les détails.",
  "done": "Terminé",
  "queued": "Filed",
  "inProgress": "En cours",
  "tapAgainToUndo": "Tapez de nouveau à dédo",
  "order": "Ordre",
  "tableTable": "Tableau {table}",
  "countCover": "Couverts : {count}",
  "countCovers": "Couverts : {count}",
  "completedAgeAgo": "Achevé il y a {age}",
  "startAll": "Commencez tous",
  "bumpAll": "Bump tous",
  "reconnectingToKitchenService": "Reconnecter au service de cuisine...",
  "liveUpdatesDegradedUsingFallbackPolling": "Mises à jour en direct dégradées, en utilisant des sondages...",
  "unableToVerifyOTPCheckTheCodeOrConnectivity": "Impossible de vérifier OTP . Vérifiez le code ou la connectivité.",
  "unableToStartItemConnectionLost": "Incapable de démarrer l'article. Connexion perdue.",
  "unableToBumpItemConnectionLost": "Incapable de bosser. Connexion perdue.",
  "unableToRecallItemConnectionLost": "Incapable de rappeler l'article. Connexion perdue.",
  "kitchenDisplay": "Intérieur de cuisine",
  "syncing": "Syncing...",
  "syncedSecondssAgo": "Synced {seconds} s ago",
  "live": "En direct",
  "reconnecting": "Reconnecter",
  "lock": "Verrouillage",
  "noOrdersHereYet": "Pas encore d'ordre ici.",
  "resolvingStation": "Station de résiliation...",
  "unableToLocateStation": "Impossible de localiser la station.",
  "enterOnetimeCodeFromManager": "Entrez un code à temps du gestionnaire",
  "verifyingCode": "Code de vérification...",
  "terminalAccessRequired": "Accès aux terminaux requis",
  "codeDigitDigit": "Numéro de code {digit}",
  "refreshCode": "Code de réfrigération",
  "requestFailedPleaseTryAgain": "Veuillez réessayer.",
  "food": "Alimentation",
  "drinks": "Bois",
  "dessert": "Dessert",
  "kitchen": "Cuisine",
  "other": "Autre",
  "minutesMin": "Minutes : {minutes}",
  "deleteRouteConfirm": "Supprimer l'itinéraire ?",
  "station": "Station kDS",
  "void": "Annulé",
  "recalled": "Rappelé",
  "createStationHeading": "Créer une station",
  "stationNotFound": "Cette station KDS n'est pas disponible.",
  "routeNotFound": "Cette règle de routage n'existe plus.",
  "invalidSettings": "Vérifiez les paramètres de la station et essayez à nouveau.",
  "invalidRouteType": "Choisissez un critère de routage valide.",
  "itemId": "Identifiant d ' élément",
  "itemTag": "Article tag",
  "menu": "Menu"
};
